module.exports = __webpack_public_path__ + "static/media/mobile-offers-group.9ff41019.png";